<template>
  <div class="page">
    <div class="card pb20">
      <p class="title">{{ $t('setting.orderEmailNotification') }}</p>
      <div class="email-list">
        <div class="email-item" v-for="(item, index) in emailList" :key="index">
          {{ item }} <i @click="removeItem(index)" class="el-icon-remove-outline"></i>
        </div>
      </div>
      <el-input :placeholder="$t('setting.pleaseInputEmail')" v-model.trim="inputEmail" maxlength="50" style="width: 200px">
        <el-button slot="append" icon="el-icon-circle-plus-outline" :disabled="emailList.length >= 10" @click="addEmail"></el-button>
      </el-input>
      <div class="mt20">
        <el-button type="primary" @click="submit">{{ $t('common.submit') }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getHkVendorConfig, updateNotificationEmail } from '../../api/setting';

export default {
  name: 'Notification',
  data() {
    return {
      emailList: [],
      inputEmail: '',
    };
  },
  created() {
    this.getEmailList();
  },
  methods: {
    getEmailList() {
      getHkVendorConfig().then((res) => {
        if (res.success) {
          this.emailList = res.data.notificationEmails || [];
        }
      });
    },
    addEmail() {
      if (!/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(this.inputEmail)) {
        this.$message.error(this.$t('setting.pleaseEnterVaildEmail'));
        return;
      }
      if (this.emailList.includes(this.inputEmail)) {
        this.$message.error(this.$t('setting.emailAlreadyExists'));
        return;
      }
      if (this.emailList.length >= 10) {
        this.$message.error(this.$t('setting.upTo10Mailboxes'));
        return;
      }
      this.emailList.push(this.inputEmail);
      this.inputEmail = '';
    },
    removeItem(index) {
      this.emailList.splice(index, 1);
    },
    submit() {
      updateNotificationEmail({
        notificationEmails: this.emailList,
      }).then((res) => {
        if (res.success) {
          this.$message.success(this.$t('error.successful'));
          this.getEmailList();
        } else {
          this.$message.error(res.message || this.$t('error.systemerror'));
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-size: 16px;
  margin-bottom: 20px;
}
.email-list {
  display: flex;
  flex-wrap: wrap;
}
.email-item {
  padding: 0 10px;
  margin-bottom: 20px;
  margin-right: 20px;
  line-height: 35px;
  border: 1px solid #ebeef5;
  border-radius: 5px;

  i {
    color: #999;

    &:hover {
      color: #1a6aff;
    }
  }
}
</style>
